import withBaseDrawer from '../../withBaseDrawer';

export default withBaseDrawer;
